<template>
    <section class="assessmentSection protectionLevelOverview aocIntroSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">70% complete</div>
            <div class="pageTitle">Tips for identifying Areas of Concern</div>
            <div class="pageText">
                <p>
                    Here are a couple things to think about when identifying areas of concern.
                </p>
            </div>
            <div class="advice">
              <!-- INLINE ADVICE -->
              <inline-advice :expand="false">
                  <div slot="title">Think about secluded areas</div>
                  <div slot="text">
                      <p>Fences and yards offer great cover for intruders to try to access a window. We call these secluded areas, they are the first areas you should think of when considering window protection.</p>
                  </div>
              </inline-advice>

              <!-- INLINE ADVICE -->
              <inline-advice :expand="false">
                  <div slot="title">Identify easily accessible windows</div>
                  <div slot="text">
                      <p>Ground level windows are the most easily accessible, think about areas with these easily accessible windows and enter them first.</p>
                  </div>
              </inline-advice>
              
            </div>
            <continue-button to="/assessment/commonly-protected-areas" text="Next" :before="mixpanelTracking" />
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([]),
        mixpanelTracking() {
            mixpanel.track('finishedAoCIntro')
        }
    }
}
</script>

<style lang="css"></style>
